import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EnvironmentService } from 'src/app/core/environment.service';
import {
  ErrorContext,
  ErrorTextsDisplayed,
  RootErrorPageInfos,
  STORAGE_KEY_ERROR,
} from '@app/core/models';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '@app/core/services/storage/storage.service';
import { WINDOW } from '@app/shared/providers/window.provider';
import { NgClass } from '@angular/common';
import { ContactUsButtonComponent } from '@app/shared/components/contact-us/contact-us-button/contact-us-button.component';
import { ContactSupportInfos } from '@app/core/config/contact-support';
import { RedirectsService } from '@app/core/services/redirect/redirects.service';

@Component({
  selector: 'app-root-error-page',
  templateUrl: './root-error-page.component.html',
  styleUrls: ['./root-error-page.component.scss'],
  imports: [NgClass, TranslateModule, ContactUsButtonComponent],
})
export class RootErrorPageComponent implements OnInit {
  private translateService = inject(TranslateService);
  private activeRoute = inject(ActivatedRoute);
  private storageService = inject(StorageService);
  private redirectsService = inject(RedirectsService);

  env = inject(EnvironmentService);
  private window = inject<Window>(WINDOW);

  infos: RootErrorPageInfos = {
    context: ErrorContext.REGISTER,
    title: this.translateService.instant('registerApp_errorPageTitle'),
    summary: this.translateService.instant(
      'registerApp_errorPageRegisterSummary',
    ),
    details: '',
  };
  displayedText: ErrorTextsDisplayed =
    this.env.getDisplayedTextInErrorPageFromEnv();
  goBackUri = '';

  ngOnInit(): void {
    const errorInfos =
      this.storageService.getSession<ContactSupportInfos>(STORAGE_KEY_ERROR);
    this.infos = {
      context: errorInfos?.context || ErrorContext.REGISTER,
      title:
        errorInfos?.title ||
        this.translateService.instant('registerApp_errorPageTitle'),
      summary:
        errorInfos?.summary ||
        this.translateService.instant('registerApp_errorPageRegisterSummary'),
      details: errorInfos?.details || '',
    };
    this.displayedText = this.env.getDisplayedTextInErrorPageFromEnv();
    this.getVerifiedGoBackUri();
  }

  goBack(): void {
    this.window.location.href = this.goBackUri;
  }

  getVerifiedGoBackUri(): void {
    this.redirectsService
      .getSecuredCallbackUri(this.activeRoute.snapshot.queryParams)
      .subscribe((callbackUri) => {
        this.goBackUri = callbackUri
          ? this.redirectsService.addQueryParamsToUrl(callbackUri, {
              origin: 'cancel',
            })
          : this.redirectsService.getGlobalRedirectURI();
      });
  }
}
